/* PIKOVA — a plan, in full.

   The cards are labels wrapping a radio, so choosing one needs no JavaScript at
   all. This exists only to keep the button honest: the word on it should say
   which term is about to be bought, because "BEGIN THIS PLAN" three cards away
   from the one you clicked is a small act of vagueness at the moment money is
   involved. */

(function () {
  'use strict';

  function label(section) {
    var button = section.querySelector('.pk-detail__add span');
    var chosen = section.querySelector('.pk-term:has(input:checked)');
    if (!button || !chosen) return;

    var base = button.dataset.pkBase;
    if (!base) {
      base = button.textContent.trim();
      button.dataset.pkBase = base;
    }

    var length = chosen.querySelector('.pk-term__length');
    if (!length) return;

    button.textContent = base + ' · ' + length.textContent.trim();
  }

  function boot() {
    document.querySelectorAll('.pk-detail').forEach(function (section) {
      if (!section.querySelector('.pk-term')) return;
      label(section);
      section.addEventListener('change', function (e) {
        if (e.target.matches && e.target.matches('[data-pk-term-input]')) label(section);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
